<template>
  <v-app>
    <v-main class="login-page">
      <!-- Glow de fundo idêntico ao da Landing Page -->
      <div class="login-glow"></div>

      <v-container
        class="fill-height login-container"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="5"
            lg="4"
            xl="3"
          >
            <!-- Voltar para Landing Page -->
            <div class="mb-4">
              <a class="login-back-link" @click="$router.push('/')">
                <v-icon size="16" color="currentColor" style="margin-right: 4px; vertical-align: middle;">mdi-arrow-left</v-icon>
                Voltar ao site
              </a>
            </div>

            <!-- Logo no padrão da Landing Page -->
            <div class="text-center mb-8">
              <div class="login-logo">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" style="vertical-align: middle; margin-right: 6px;">
                  <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" fill="#FF771C"/>
                </svg>
                <span class="lp-logo-text">Elev<span class="lp-logo-ment">Ment</span></span>
              </div>
              <div class="login-subtitle">Plataforma de Gestão de Performance</div>
            </div>

            <v-card
              class="login-card"
              :loading="loading"
              flat
              dark
              color="#0F0F11"
            >
              <v-card-text class="pa-8">
                <div class="text-h5 font-weight-bold mb-1" style="color: #FFFFFF;">Entrar na plataforma</div>
                <div class="text-body-2 mb-6" style="color: rgba(255, 255, 255, 0.5);">Insira suas credenciais para acessar</div>

                <!-- Email -->
                <div class="mb-4">
                  <label class="login-label">E-mail</label>
                  <v-text-field
                    v-model="email"
                    placeholder="seu@email.com"
                    outlined
                    dense
                    :disabled="loading"
                    :rules="[rules.required, rules.email]"
                    @keyup.enter="login"
                    hide-details="auto"
                    class="login-input"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="18" color="rgba(255, 255, 255, 0.4)">mdi-email-outline</v-icon>
                    </template>
                  </v-text-field>
                </div>

                <!-- Senha -->
                <div class="mb-5">
                  <label class="login-label">Senha</label>
                  <v-text-field
                    v-model="password"
                    placeholder="••••••••"
                    :type="showPassword ? 'text' : 'password'"
                    outlined
                    dense
                    :disabled="loading"
                    :rules="[rules.required]"
                    @keyup.enter="login"
                    hide-details="auto"
                    class="login-input"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="18" color="rgba(255, 255, 255, 0.4)">mdi-lock-outline</v-icon>
                    </template>
                    <template v-slot:append>
                      <v-icon
                        size="18"
                        color="rgba(255, 255, 255, 0.4)"
                        style="cursor: pointer;"
                        @click="showPassword = !showPassword"
                      >
                        {{ showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}
                      </v-icon>
                    </template>
                  </v-text-field>
                </div>

                <!-- Mensagens de Erro/Sucesso -->
                <v-alert
                  v-if="errorMessage"
                  type="error"
                  dismissible
                  dense
                  class="mb-4"
                  @input="errorMessage = ''"
                >
                  {{ errorMessage }}
                </v-alert>

                <v-alert
                  v-if="successMessage"
                  type="success"
                  dismissible
                  dense
                  class="mb-4"
                  @input="successMessage = ''"
                >
                  {{ successMessage }}
                  <template v-slot:close>
                    <v-icon color="#86868B" style="cursor:pointer">mdi-close</v-icon>
                  </template>
                </v-alert>

                <!-- Botão Entrar -->
                <v-btn
                  color="#FF771C"
                  dark
                  large
                  block
                  :loading="loading"
                  :disabled="!isFormValid"
                  class="login-btn mb-4"
                  @click="login"
                >
                  Entrar
                </v-btn>

                <!-- Esqueci a senha -->
                <div class="text-center">
                  <a
                    href="#"
                    class="login-forgot-link"
                    @click.prevent="forgotPassword"
                  >
                    Esqueceu sua senha?
                  </a>
                </div>
              </v-card-text>
            </v-card>

            <!-- Footer -->
            <div class="text-center mt-6">
              <span class="login-footer">&copy; {{ new Date().getFullYear() }} ElevMent. Todos os direitos reservados.</span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { initializeApp } from 'firebase/app'
import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth'

export default {
  name: 'Login',

  data: () => ({
    email: '',
    password: '',
    showPassword: false,
    loading: false,
    errorMessage: '',
    successMessage: '',
    
    // Firebase instances
    firebaseApp: null,
    auth: null,

    // Regras de validação
    rules: {
      required: value => !!value || 'Campo obrigatório',
      email: value => {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return pattern.test(value) || 'E-mail inválido'
      },
    },
  }),

  computed: {
    isFormValid() {
      return (
        this.email &&
        this.password &&
        this.rules.email(this.email) === true
      )
    },
  },

  created() {
    // Inicializar Firebase (configure com suas credenciais)
    this.initFirebase()
    
    // Verificar se já está logado
    this.checkAuthStatus()
  },

  methods: {
    initFirebase() {
      // Configuração Firebase do projeto meumentor-dev
      const firebaseConfig = {
        apiKey: 'AIzaSyDPdmR0PV7h0WRfBPGGPzJ6RQEacB1u8IM',
        authDomain: 'meumentor-dev.firebaseapp.com',
        projectId: 'meumentor-dev',
        storageBucket: 'meumentor-dev.appspot.com',
      }

      // Inicializar apenas se ainda não foi inicializado
      if (!this.firebaseApp) {
        try {
          this.firebaseApp = initializeApp(firebaseConfig)
          this.auth = getAuth(this.firebaseApp)
          console.log('✅ Firebase inicializado com sucesso:', {
            projectId: firebaseConfig.projectId,
            authDomain: firebaseConfig.authDomain,
            hasAuth: !!this.auth,
          })
        } catch (error) {
          console.error('❌ Erro ao inicializar Firebase:', error)
          throw error
        }
      }
    },

    async login() {
      if (!this.isFormValid) {
        this.errorMessage = 'Por favor, preencha todos os campos corretamente'
        return
      }

      this.loading = true
      this.errorMessage = ''
      this.successMessage = ''

      try {
        // ============================================================
        // INTEGRAÇÃO COMPLETA - FIREBASE + BACKEND
        // ============================================================
        
        // Garantir que Firebase está inicializado
        if (!this.auth) {
          console.log('Firebase não estava inicializado, inicializando agora...')
          this.initFirebase()
        }
        
        if (!this.auth) {
          throw new Error('Não foi possível inicializar o Firebase. Verifique as configurações.')
        }
        
        console.log('✅ Auth pronto, tentando autenticar...')
        
        // 1. Autenticar com Firebase
        const userCredential = await signInWithEmailAndPassword(
          this.auth,
          this.email,
          this.password,
        )

        console.log('✅ Autenticado com Firebase!')

        // 2. Obter o token ID do Firebase (JWT)
        const idToken = await userCredential.user.getIdToken()
        
        console.log('✅ Firebase idToken obtido:', idToken.substring(0, 50) + '...')

        // 3. Chamar o backend para validar e obter dados do usuário
        const response = await this.callBackendLogin(idToken)

        if (response.ok) {
          const userData = await response.json()
          
          console.log('✅ Usuário autenticado:', userData)
          
          // 4. Armazenar dados do usuário (incluindo tenantId que vem do backend)
          this.storeUserData(userData, idToken)
          
          this.successMessage = 'Login realizado com sucesso!'
          
          // 5. Redirecionar baseado no role do usuário
          setTimeout(() => {
            this.redirectBasedOnRole(userData.role)
          }, 1000)
        } else {
          const errorData = await response.text()
          console.error('❌ Erro do backend:', response.status, errorData)
          this.handleBackendError(response.status, errorData)
        }
      } catch (error) {
        console.error('Erro no login:', error)
        this.handleFirebaseError(error)
      } finally {
        this.loading = false
      }
    },

    async callBackendLogin(firebaseToken) {
      const backendUrl = process.env.VUE_APP_BACKEND_URL || 'http://localhost:8080'
      
      console.log('🔄 Chamando backend:', `${backendUrl}/api/auth/login`)
      
      return fetch(`${backendUrl}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${firebaseToken}`,
        },
      })
    },

    storeUserData(userData, token) {
      // Extrair tenantId do userData retornado pelo backend
      const tenantId = userData.tenantId
      
      console.log('💾 Armazenando dados do usuário:', {
        userId: userData.id,
        email: userData.email,
        role: userData.role,
        tenantId: tenantId,
      })
      
      // Armazenar no localStorage
      localStorage.setItem('user', JSON.stringify(userData))
      localStorage.setItem('firebaseToken', token)
      localStorage.setItem('tenantId', tenantId)
      
      // Armazenar no Vuex (se estiver usando)
      if (this.$store) {
        this.$store.commit('setUser', userData)
        this.$store.commit('setToken', token)
        this.$store.commit('setTenantId', tenantId)
      }
    },

    handleBackendError(status, errorMessage) {
      switch (status) {
        case 401:
          this.errorMessage = 'Token inválido ou expirado. Tente novamente.'
          break
        case 403:
          this.errorMessage = errorMessage || 'Acesso negado. Tenant inválido ou usuário desativado.'
          break
        case 400:
          this.errorMessage = errorMessage || 'Dados inválidos. Verifique o token do Firebase.'
          break
        default:
          this.errorMessage = 'Erro ao realizar login. Tente novamente mais tarde.'
      }
    },

    handleFirebaseError(error) {
      console.error('Erro Firebase:', error)
      
      switch (error.code) {
        case 'auth/invalid-email':
          this.errorMessage = 'E-mail inválido'
          break
        case 'auth/user-disabled':
          this.errorMessage = 'Usuário desabilitado'
          break
        case 'auth/user-not-found':
          this.errorMessage = 'Usuário não encontrado'
          break
        case 'auth/wrong-password':
          this.errorMessage = 'Senha incorreta'
          break
        case 'auth/too-many-requests':
          this.errorMessage = 'Muitas tentativas. Tente novamente mais tarde.'
          break
        default:
          this.errorMessage = 'Erro ao autenticar. Verifique suas credenciais.'
      }
    },

    async checkAuthStatus() {
      // Verificar se já existe um token válido
      const token = localStorage.getItem('firebaseToken')
      const user = localStorage.getItem('user')
      
      if (token && user) {
        const userData = JSON.parse(user)
        // Redirecionar baseado no role
        this.redirectBasedOnRole(userData.role)
      }
    },

    redirectBasedOnRole(role) {
      console.log('🔀 Redirecionando baseado no role:', role)
      
      switch (role) {
        case 'TENANT_ADMIN':
          this.$router.push('/tenant-admin')
          break
        case 'MANAGER':
          // MANAGER vai para dashboard padrão
          this.$router.push('/')
          break
        case 'PLATFORM_OWNER':
          this.$router.push('/')
          break
        default:
          // USER e outros roles vão para dashboard padrão
          this.$router.push('/')
          break
      }
    },

    async forgotPassword() {
      if (!this.email) {
        this.errorMessage = 'Por favor, informe seu e-mail para recuperar a senha'
        return
      }

      if (!this.auth) {
        await this.initFirebase()
      }

      try {
        await sendPasswordResetEmail(this.auth, this.email)
        this.successMessage = 'E-mail de recuperação enviado! Verifique sua caixa de entrada.'
        this.errorMessage = ''
      } catch (error) {
        this.errorMessage = 'Erro ao enviar e-mail de recuperação. Verifique o e-mail informado.'
        console.error(error)
      }
    },
  },
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background: #0A0A0B !important;
  color: #FFFFFF !important;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  position: relative;
  overflow: hidden;
}

.login-glow {
  position: absolute;
  top: -20%; left: 50%; transform: translateX(-50%);
  width: 1000px; height: 600px;
  background: radial-gradient(ellipse at 50% 10%, rgba(255,119,28,0.18) 0%, transparent 70%);
  pointer-events: none;
  z-index: 0;
}

.login-container {
  position: relative;
  z-index: 1;
}

.fill-height {
  min-height: 100vh;
}

.login-back-link {
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.6) !important;
  cursor: pointer;
  transition: color 0.2s;
  text-decoration: none;
}

.login-back-link:hover {
  color: #FF771C !important;
}

.login-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.lp-logo-text {
  font-size: 32px;
  font-weight: 700;
  color: #FFFFFF;
  letter-spacing: -0.01em;
}

.lp-logo-ment {
  color: rgba(255, 255, 255, 0.45);
}

.login-subtitle {
  font-size: 14px;
  margin-top: 6px;
  color: rgba(255, 255, 255, 0.55);
}

/* Ancorado em .login-page p/ vencer as regras globais de App.vue
   (.theme--dark/.theme--light .v-card.v-card--flat) que vazam quando o
   tema global do Vuetify persiste como dark após logout de admin. */
.login-page .login-card.v-card {
  border-radius: 14px !important;
  background: #0F0F11 !important;
  border: none !important;
  outline: none !important;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.05), 0 28px 80px rgba(0, 0, 0, 0.7) !important;
}

.login-card >>> .v-card__text {
  background: #0F0F11 !important;
}

.login-label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 6px;
  color: rgba(255, 255, 255, 0.85);
}

.login-input >>> .v-input__slot {
  background: #1A1A1D !important;
  border-radius: 10px !important;
  min-height: 44px !important;
  transition: all 0.15s ease;
}

.login-input:hover >>> .v-input__slot {
  background: #212125 !important;
}

.login-input >>> fieldset {
  border-color: rgba(255, 255, 255, 0.08) !important;
  border-radius: 10px !important;
}

.login-input:hover >>> fieldset {
  border-color: rgba(255, 255, 255, 0.15) !important;
}

.login-input >>> .v-input--is-focused fieldset {
  border-color: #FF771C !important;
  border-width: 1.5px !important;
}

.login-input >>> input {
  color: #FFFFFF !important;
}

.login-input >>> input::placeholder {
  color: rgba(255, 255, 255, 0.3) !important;
}

.login-input >>> .v-messages__message {
  color: rgba(255, 255, 255, 0.5) !important;
}

.login-input.v-input--has-state.error--text >>> .v-messages__message {
  color: #FF5252 !important;
}

.login-btn {
  border-radius: 10px !important;
  height: 48px !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  box-shadow: 0 1px 3px rgba(255, 119, 28, 0.3) !important;
  background: linear-gradient(135deg, #FF771C, #F6AB2E) !important;
}

.login-btn:hover {
  box-shadow: 0 4px 16px rgba(255, 119, 28, 0.4) !important;
  transform: translateY(-1px);
}

.login-btn.v-btn--disabled {
  background: rgba(255, 119, 28, 0.2) !important;
  color: rgba(255, 255, 255, 0.35) !important;
  box-shadow: none !important;
}

.login-forgot-link {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5) !important;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.15s ease;
}

.login-forgot-link:hover {
  color: #FF771C !important;
}

.login-footer {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.35);
}

.login-page >>> .v-alert {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 8px !important;
}

.login-page >>> .v-alert.error {
  background: rgba(255, 82, 82, 0.1) !important;
  border-color: rgba(255, 82, 82, 0.25) !important;
}

.login-page >>> .v-alert.success {
  background: rgba(76, 175, 80, 0.1) !important;
  border-color: rgba(76, 175, 80, 0.25) !important;
}

.login-page >>> .v-alert__content {
  color: #FFFFFF !important;
}
</style>
